namespace Gamification.Gamification {
    export interface UtentiProdottiParametriGlobaliForm {
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdentifierPunteggio: Serenity.StringEditor;
        PunteggioNome: Serenity.StringEditor;
        PunteggioValore: Serenity.StringEditor;
        IdentifierCrediti: Serenity.StringEditor;
        CreditiNome: Serenity.StringEditor;
        CreditiValore: Serenity.StringEditor;
        IdentifierEsperienza: Serenity.StringEditor;
        EsperienzaNome: Serenity.StringEditor;
        EsperienzaValore: Serenity.StringEditor;
        IdentifierLivello: Serenity.StringEditor;
        Livello: Serenity.IntegerEditor;
    }

    export class UtentiProdottiParametriGlobaliForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiParametriGlobali';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiParametriGlobaliForm.init)  {
                UtentiProdottiParametriGlobaliForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(UtentiProdottiParametriGlobaliForm, [
                    'IdUtenteProdotto', w0,
                    'IdentifierPunteggio', w1,
                    'PunteggioNome', w1,
                    'PunteggioValore', w1,
                    'IdentifierCrediti', w1,
                    'CreditiNome', w1,
                    'CreditiValore', w1,
                    'IdentifierEsperienza', w1,
                    'EsperienzaNome', w1,
                    'EsperienzaValore', w1,
                    'IdentifierLivello', w1,
                    'Livello', w0
                ]);
            }
        }
    }
}
